import { get } from 'lodash';
import { required } from '@utils/validators';
import { EventsExportStatisticsShiftCyclesModal } from '@modules/events/EventsExportStatisticsShiftCyclesModal';

const labelFnParticipant = o => {
  return get(o, 'person.fullName');
};

const labelFnVehicle = o => {
  return get(o, 'registrationNumber');
};

const labelFnDelict = o => {
  return get(o, 'type.name') ? `${get(o, 'number')} - ${get(o, 'type.name')}` : `${get(o, 'number', '')}`;
};

const labelFnOfficers = o => {
  return get(o, 'fullName');
};

const labelFnPhotos = o => {
  return get(o, 'name');
};

export const remoteAutocompleteFields = {
  violationId: {
    url: '/metropolis/api/ed/delict/violations'
  },
  proceedingNumber: {
    url: '/metropolis/api/common/sps/documents',
    labelFunction: o => get(o, 'proceedingNumber'),
    valueFunction: o => get(o, 'proceedingNumber')
  },
  officerWitnesses: {
    url: '/metropolis/api/hr/employees',
    labelFunction: o => get(o, 'fullName'),
    valueFunction: o => get(o, 'fullName')
  },
  lawList: {
    url: '/metropolis/api/hr/employees',
    labelFunction: o => get(o, 'fullName'),
    valueFunction: o => get(o, 'id')
  },
  employeeFirst: {
    url: '/metropolis/api/hr/employees',
    labelFunction: o => get(o, 'fullName'),
    valueFunction: o => get(o, 'fullName')
  },
  employeeSecond: {
    url: '/metropolis/api/hr/employees',
    labelFunction: o => get(o, 'fullName'),
    valueFunction: o => get(o, 'fullName')
  },
  stationId: {
    url: '/metropolis/api/ed/stations'
  },
  warehouseId: {
    url: '/metropolis/api/wa/warehouses'
  },
  certificateTypeId: {
    url: '/metropolis/api/hr/certificateTypes'
  }
};

export const remoteAutocompleteMultipleFields = {
  employeeList: {
    name: 'employeeList',
    label: 'Strážnici',
    labelFunction: labelFnOfficers,
    valueFunction: o => get(o, 'id'),
    type: 'remote_chip_input',
    url: '/metropolis/api/hr/employees',
    active: true,
    modalButtonProps: {
      name: 'addOfficersButton',
      type: 'modal_button',
      label: 'Přidat strážníky z cyklů směn',
      style: { width: '100%' },
      oldValues: 'employeeList',
      ModalComponent: EventsExportStatisticsShiftCyclesModal,
      active: true
    }
  },
  shiftEmployeeList: {
    name: 'shiftEmployeeList',
    label: 'Strážnici',
    labelFunction: labelFnOfficers,
    valueFunction: o => get(o, 'id'),
    type: 'remote_chip_input',
    url: '/metropolis/api/hr/employees',
    active: true,
    modalButtonProps: {
      name: 'addOfficersButton',
      type: 'modal_button',
      label: 'Přidat strážníky z cyklů směn',
      style: { width: '100%' },
      oldValues: 'shiftEmployeeList',
      ModalComponent: EventsExportStatisticsShiftCyclesModal,
      active: true
    }
  },
  shiftList: {
    name: 'shiftList',
    label: 'Směny',
    type: 'remote_chip_input',
    labelFunction: o => get(o, 'name'),
    valueFunction: o => get(o, 'id'),
    url: '/metropolis/api/hr/workplan/shift',
    active: true
  },
  lawList: {
    name: 'lawList',
    label: 'Zákony',
    type: 'remote_chip_input',
    labelFunction: o => get(o, 'lawName'),
    valueFunction: o => get(o, 'law'),
    url: '/metropolis/api/ed/delict/types/laws',
    active: true
  }
};

export const autocompleteFields = {
  vehicleId: {
    labelFunction: labelFnVehicle,
    items: 'vehicles'
  },
  eventParticipantId: {
    items: 'participants',
    labelFunction: labelFnParticipant
  },
  eventUserId: {
    items: 'participants',
    labelFunction: labelFnParticipant
  },
  eventOtherPersonId: {
    items: 'participants',
    labelFunction: labelFnParticipant
  },
  firstSuspectedId: {
    items: 'participants',
    labelFunction: labelFnParticipant
  },
  secondSuspectedId: {
    items: 'participants',
    labelFunction: labelFnParticipant
  },
  victimId: {
    items: 'participants',
    labelFunction: labelFnParticipant
  },
  delictId: {
    items: 'delicts',
    labelFunction: labelFnDelict
  },
  eventOfficer: {
    items: 'officers',
    labelFunction: labelFnOfficers,
    valueFunction: labelFnOfficers
  },
  notificationOfficer: {
    items: 'officers',
    labelFunction: labelFnOfficers,
    valueFunction: labelFnOfficers
  },
  photoIds: {
    items: 'photos',
    labelFunction: labelFnPhotos
  }
};

export const reportDataFields = {
  eventId: 'id'
};

export const validations = {
  required
};



// WEBPACK FOOTER //
// ./src/components/reports/_reportsEnums.ts